<div class="import-wizard-component" [class.close]="shouldClose">
  <steps-manager [stepsCount]="stepsCount" [currentStep]="currentStep" [displayCloseButton]="true" (onCloseClicked)="onCloseClicked()"></steps-manager>
  <div>&nbsp;</div>
  <header class="import-section" style="margin-bottom: 20px;" [hidden]="!showUploadSection">
    <h1>{{ 'import.importTitle' | translate }}</h1>
  </header>
  <div>&nbsp;</div>
  <section class="import-section currencies-section" [hidden]="!(currentStep === 1 && showCurrencySection)">
    <h2>{{'import.unitOfLengthAssignment' | translate}}</h2>

    <p class="import-help-text">
      {{'import.helpTextCurrencies' | translate}}<br />
    </p>

    <kendo-grid [data]="currencies" (cellClick)="cellEditHandler($event)">
      <kendo-grid-column field="CurrencyName" title="Currency name">
      </kendo-grid-column>

      <kendo-grid-column field="DefaultUnitOfLengthId" title="Default unit of length">
        <ng-template kendoGridCellTemplate let-dataItem>
          {{ dataItem.DefaultUnitOfLength}}
        </ng-template>
        <ng-template kendoGridEditTemplate let-dataItem="dataItem" let-column="column">
          <div [formGroup]="formGroup">
            <select formControlName="DefaultUnitOfLengthId" class="import-dropdown-list" style="width: 40%;"
                    (change)="unitOfLengthChanged($event.target.value, dataItem)">
              <option *ngFor="let item of unitOfLengthList" [value]="item.oid">
                {{item.description}}
              </option>
            </select>
          </div>
        </ng-template>
      </kendo-grid-column>
    </kendo-grid>
  </section>

  <section class="import-section" [hidden]="currentStep !== 2">
    <h2>{{ 'import.importFile' | translate }}</h2>
    <kendo-upload #kendoUpload [saveUrl]="uploadSaveUrl" [autoUpload]="false" actionsLayout="start" [restrictions]="uploadRestrictions" [batch]="true"
                  [formGroup]="filesFormGroup" (select)="onFileSelect($event)" (clear)="onClearFiles()"
                  (upload)="onUploadFiles()" class="uploadFiles">
      <ng-template kendoUploadFileTemplate let-files let-state="state">
        <label class="import-file-name-label">{{ files[0].name }}</label>
        <select class="import-dropdown-list" style="width: 25%;" [formControlName]="files[0].uid" (change)="templateDropdownChanged($event, files[0])">
          <option *ngFor="let item of calculationModelTemplatesList" [ngValue]="item.id">{{item.name}}</option>
        </select>
        <button kendoButton (click)="onRemoveFile(kendoUpload, files[0].uid)" class="import-remove-file-btn">
          {{'import.remove' | translate}}
        </button>
      </ng-template>
    </kendo-upload>
  </section>

  <section class="import-section uploaded-files-section" [hidden]="currentStep !== 3">
    <h2>{{ 'import.importFile' | translate }}</h2>
    <p class="import-help-text" *ngIf="validationResult && validationResult.isError">
      {{'import.issuesWithFiles' | translate}}<br />
      {{'import.pleaseFixIssuesWithFiles' | translate}}<br /><br />
      <span *ngFor="let entry of validationResult.entries">- {{entry.fieldName}}: {{entry.message}}<br /><br /></span>
    </p>
    <div class="uploadedFiles">
      <kendo-grid [data]="uploadedFiles" [selectable]="{enabled: false, checkboxOnly: true}" [scrollable]="'scrollable'" (remove)="onRemoveUploadedFile($event)" class="skip-default-content-height">
        <kendo-grid-column [field]="'fileName'" [title]="'Name'"></kendo-grid-column>
        <kendo-grid-column [field]="'fileImportGuid'" [title]="'File import Guid'"></kendo-grid-column>
        <kendo-grid-column [field]="'groupDescription'" [title]="'Group'"></kendo-grid-column>
        <kendo-grid-column [field]="'mappingVersionDescription'" [title]="'Mapping'" *ngIf="isAdmin"></kendo-grid-column>
        <kendo-grid-command-column [width]="350">
          <ng-template kendoGridCellTemplate let-dataItem>
            <button kendoButton (click)="downloadFileItem(dataItem)">{{'import.download' | translate}}</button>
            <button kendoGridRemoveCommand>{{'import.remove' | translate}}</button>
          </ng-template>
        </kendo-grid-command-column>
      </kendo-grid>
    </div>

  </section>

  <section class="import-section preview-grids" *ngIf="currentStep === 4">
    <p class="import-help-text" *ngIf="validationResult && validationResult.isError">
      {{'import.issuesWithFiles' | translate}}<br />
      {{'import.pleaseFixIssuesWithFiles' | translate}}<br /><br />
      <span *ngFor="let entry of validationResult.entries">- {{entry.fieldName}}: {{entry.message}}<br /><br /></span>
    </p>
    <div *ngIf="previewData" class="previewData">
      <h2>{{'import.previewTitle' | translate}}</h2>
      <p class="import-help-text">
        {{'import.previewLine1' | translate}}<br />
        {{'import.previewLine2' | translate}}<br />
        {{'import.previewLine3' | translate}}<br />
      </p>

      <div *ngIf="hasEmptyUnitOfLength" class="warning">
        <p>
          <strong>WARNING</strong>: We couldn't determine the Unit of Length for some of the imports. <br />
          Please check and correct any missing Local and Report Unit of Length in the report form after the import succeeded.
        </p>
      </div>
      <div class="tabstrip-wrapper">

        <kendo-tabstrip>
          <kendo-tabstrip-tab *ngFor="let import of previewData.data | keyvalue; let i = index" [cssClass]="{'missingData': !allPropertiesAssigned && import.key.indexOf('PropertyLevelImport') >= 0 }" title="{{iprs.getPreviewImportTitle(import.key)}}" [selected]="i === 0">
            <ng-template kendoTabContent>
              <ng-container [ngTemplateOutlet]="importPreviewGrid"
                            [ngTemplateOutletContext]="{import:import}">
              </ng-container>
            </ng-template>

          </kendo-tabstrip-tab>
        </kendo-tabstrip>
      </div>
    </div>
  </section>

  <div class="buttons-container">
    <button kendoButton class="prev" *ngIf="currentStep > 1" (click)="prevStep()">{{'calculationModel.back' | translate}}</button>
    <button kendoButton class="next" *ngIf="isNextEnabled() && currentStep < stepsCount" (click)="nextStep()">{{'calculationModel.next' | translate}}</button>
    <button kendoButton class="next" *ngIf="(currentStep === 4 && !validationResult) || (currentStep === 4 && validationResult && !validationResult.isError)" (click)="continueImport()">{{'import.importButton' | translate}}</button>
  </div>

</div>

<ng-template #importPreviewGrid let-import='import'>
  <div class="import-grid-container" *ngIf="import.value && import.value.DataRoot && import.value.DataRoot.Data && import.value.DataRoot.Data.length">
    <kendo-grid [data]="import.value.DataRoot.Data" [scrollable]="'scrollable'">
      <ng-container *ngFor="let column of import.value.DataRoot.Data[0] | keyvalue | sortImportFields">
        <kendo-grid-column *ngIf="column.key !== 'selectableProperties' && column.key !== 'isFlatFile'"
                           [field]="column.key"
                           [title]="iprs.getPreviewColumnTitle(import.key, column.key)"
                           [width]="iprs.getPreviewColumnWidth(import.key, column.key)"
                           [hidden]="!iprs.shouldShowField(import.key, column.key)"
                           [format]="iprs.getFormat(import.key, column.key)">
          <ng-template *ngIf="column.key === 'TargetPropertyId'" kendoGridCellTemplate let-dataItem>
            <kendo-dropdownlist [(ngModel)]="dataItem.TargetPropertyId"
                                [data]="dataItem.selectableProperties"
                                [textField]="'description'"
                                [disabled]="dataItem.TargetPropertyId === -1"
                                [valueField]="'oid'"
                                [valuePrimitive]="true"
                                style="width: 350px;"
                                (ngModelChange)="previewPropertyChanged()">
            </kendo-dropdownlist>
          </ng-template>
        </kendo-grid-column>
      </ng-container>
    </kendo-grid>
  </div>
</ng-template>
